module.exports = __webpack_public_path__ + "img/add_lock_6.b5ab34b3.png";